import { Routes } from '@angular/router';
import { FaqGuard } from './guards';
import { provideState } from '@ngrx/store';

import * as fromStore from './store';
import { provideEffects } from '@ngrx/effects';
import { FaqPageComponent } from './containers/faq-page/faq-page.component';
import { MetaGuard } from '../guards/meta.guard';

export const routes: Routes = [
  {
    path: '',
    component: FaqPageComponent,
    canActivate: [MetaGuard, FaqGuard],
    providers: [
      provideState(fromStore.featureKey, fromStore.reducers, {
        metaReducers: fromStore.metaReducers,
      }),
      provideEffects(fromStore.effects),
    ],
  },
];
